<template>
  <header
    class="bg-white shadow-sm h-16 fixed w-full z-50 flex items-center justify-between px-4"
  >
    <div class="flex items-center space-x-2">
      <button @click="toggleSidebar" class="p-2 hover:bg-gray-100 rounded-lg">
        <i class="fas fa-bars text-gray-600"></i>
      </button>
      <div class="flex items-center space-x-2">
        <img src="@/assets/logo.png" class="h-8" alt="logo" />
        <span class="text-xl font-semibold text-gray-800">内府云途 ERP</span>
      </div>
    </div>
    <div class="flex items-center space-x-6">
      <!-- <div class="relative">
        <input
          type="text"
          placeholder="搜索..."
          class="pl-10 pr-4 py-2 border border-gray-200 rounded-lg w-64 text-sm focus:outline-none focus:border-blue-500"
        />
        <i class="fas fa-search absolute left-3 top-3 text-gray-400"></i>
      </div> -->
      <!-- 进货按钮 -->
      <div v-if="false" class="relative">
        <button @click="togglePurchasePanel" class="relative p-2 hover:bg-gray-100 rounded-lg">
          <i class="fas fa-truck text-gray-600"></i>
          <span
            v-if="pendingPurchaseCount > 0"
            class="absolute top-0 right-0 h-4 w-4 bg-orange-500 rounded-full text-xs text-white flex items-center justify-center"
            >{{ pendingPurchaseCount }}</span
          >
        </button>
        <!-- 进货面板 -->
        <div v-if="showPurchasePanel" class="absolute right-0 mt-2 w-96 bg-white rounded-lg shadow-lg z-[1000]" @click.stop>
          <div class="p-4 border-b">
            <div class="flex justify-between items-center">
              <h3 class="text-sm font-semibold">进货待销售</h3>
              <span class="text-xs text-gray-500">最近5条记录</span>
            </div>
          </div>
          <div class="max-h-96 overflow-y-auto">
            <div v-if="pendingPurchases.length === 0" class="p-4 text-center text-gray-500">
              暂无待销售进货单
            </div>
            <div v-else v-for="purchase in pendingPurchases" :key="purchase.id" 
                 class="p-3 border-b hover:bg-orange-50">
              <div class="space-y-2">
                <div class="flex justify-between items-start">
                  <div class="flex-1">
                    <div class="text-sm font-medium text-gray-900">{{ purchase.orderNo }}</div>
                    <div class="text-xs text-gray-500">{{ formatDate(purchase.createdOn) }}</div>
                  </div>
                  <div class="text-sm font-medium text-orange-600">￥{{ purchase.totalAmount }}</div>
                </div>
                <div class="text-xs text-gray-600">
                  <div>商品：{{ getProductNames(purchase.products) }}</div>
                  <div>供应商：{{ purchase.suppliersName }}</div>
                  <div v-if="purchase.remarks">备注：{{ purchase.remarks }}</div>
                </div>
                <div class="flex justify-end space-x-2">
                  <button @click="markAsSold(purchase)" 
                          class="px-3 py-1 text-xs bg-green-500 text-white rounded hover:bg-green-600">
                    标记已售
                  </button>
                  <button @click="convertToSales(purchase)" 
                          class="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600">
                    转销售
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="relative"  v-if="false" >
        <button @click="toggleMessagePanel" class="relative p-2 hover:bg-gray-100 rounded-lg">
          <i class="fas fa-bell text-gray-600"></i>
          <span
            v-if="unreadCount > 0"
            class="absolute top-0 right-0 h-4 w-4 bg-red-500 rounded-full text-xs text-white flex items-center justify-center"
            >{{ unreadCount }}</span
          >
        </button>
        <!-- 消息面板 -->
        <div v-if="showMessagePanel" class="absolute right-0 mt-2 w-96 bg-white rounded-lg shadow-lg z-[1000]" @click.stop>
          <div class="p-4 border-b">
            <div class="flex justify-between items-center">
              <h3 class="text-sm font-semibold">消息通知</h3>
              <router-link to="/messagelist" class="text-xs text-blue-600 hover:text-blue-800">消息列表</router-link>
            </div>
          </div>
          <div class="max-h-96 overflow-y-auto">
            <div v-if="messages.length === 0" class="p-4 text-center text-gray-500">
              暂无消息
            </div>
            <div v-else v-for="message in messages" :key="message.id" 
                 class="p-3 border-b hover:bg-blue-50 cursor-pointer"
                 :class="{'bg-gray-50': !message.isRead}"  @click="handleMessageClick(message)">
              <div class="flex justify-between items-start">
                <div class="flex-1 space-y-2"> 
                  <div class="flex items-start gap-4">
                    <div class="flex-1 min-w-0 text-xs">{{ message.content }}</div>
                    <div v-if="message.attachmentUrl.length > 0" class="shrink-0 flex flex-wrap gap-1">
                      <img 
                        v-for="(file, index) in message.attachmentUrl"
                        :key="index"
                        :src="file.url"
                        class="w-12 h-12 object-cover rounded border cursor-pointer" 
                        mode="aspectFit"
                        style="margin: 5px;" 
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-- 操作按钮区域 -->
              <div class="mt-2 flex justify-between items-center">
                <span class="flex-1 px-3 py-1 text-xs text-gray-500">{{ formatDate(message.createdOn) }}</span>
                <!-- 需要审批的消息显示审批按钮 -->
                <template v-if="message.isShowButton">
                  <button @click.stop="handleApprove(message.id)" 
                          class="px-3 py-1 text-xs bg-green-500 text-white rounded hover:bg-green-600">
                    通过
                  </button>
                  <!-- <button @click.stop="handleReject(message.id)"
                          class="ml-1 px-3 py-1 text-xs bg-red-500 text-white rounded hover:bg-red-600">
                    驳回
                  </button> -->
                  <button v-if="!message.isRead" @click.stop="markAsRead(message.id)"
                          class="ml-1 px-3 py-1 text-xs bg-gray-200 text-gray-700 rounded hover:bg-gray-300">
                    标记已读
                  </button>
                </template>
                <!-- 不需要审批的消息显示已读按钮 -->
                <template v-else>
                  <button v-if="!message.isRead" @click.stop="markAsRead(message.id)"
                          class="px-3 py-1 text-xs bg-gray-200 text-gray-700 rounded hover:bg-gray-300">
                    标记已读
                  </button>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="relative">
        <button @click="toggleUserMenu" class="flex items-center space-x-3 p-2 hover:bg-gray-100 rounded-lg">
          <img :src="avatarUrl" class="w-8 h-8 rounded-full object-cover" />
          <span class="text-gray-700">{{ userInfo.name }}</span>
          <span v-if="roleBadge.text" :class="['text-xs px-2 py-0.5 rounded-full whitespace-nowrap border', roleBadge.className]">
            {{ roleBadge.text }}
          </span>
          <i class="fas fa-chevron-down text-gray-400 text-xs"></i>
        </button>
        <!-- 用户下拉菜单 -->
        <div v-if="showUserMenu" class="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg z-[1000]" @click.stop>
          <div class="py-2">
            <button @click="showChangeAvatarDialog" class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center">
              <i class="fas fa-user-circle mr-3 text-gray-400"></i>
              修改头像
            </button>
            <button @click="showChangeAuthCodeDialog" class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center">
              <i class="fas fa-shield-alt mr-3 text-gray-400"></i>
              修改授权码
            </button>
            <button @click="showChangePasswordDialog" class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center">
              <i class="fas fa-key mr-3 text-gray-400"></i>
              修改密码
            </button>
            <button @click="logout" class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center">
              <i class="fas fa-sign-out-alt mr-3 text-gray-400"></i>
              退出登录
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>
  
  <!-- 驳回理由对话框 -->
  <div v-if="showRejectDialog" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[2000]">
    <div class="bg-white rounded-lg p-6 w-96 shadow-xl">
      <h3 class="text-lg font-semibold mb-4">请输入驳回理由</h3>
      <div class="mb-4">
        <textarea 
          v-model="rejectReason" 
          class="w-full border rounded-lg p-2 text-sm focus:outline-none focus:border-blue-500" 
          rows="4"
          placeholder="请输入驳回理由..."
        ></textarea>
        <p v-if="rejectReasonError" class="text-red-500 text-xs mt-1">{{ rejectReasonError }}</p>
      </div>
      <div class="flex justify-end space-x-2">
        <button 
          @click="cancelReject" 
          class="px-4 py-2 text-sm bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
        >
          取消
        </button>
        <button 
          @click="submitReject" 
          class="px-4 py-2 text-sm bg-red-500 text-white rounded hover:bg-red-600"
        >
          确认驳回
        </button>
      </div>
    </div>
  </div>
  <ComponentDialog v-model="showMessageDetail" width="1000px">
  <MessageDetail 
    v-model="showMessageDetail"
    :message="messageData"
    :visible="true"
    @refresh="loadMessages"
  />
</ComponentDialog>

  <!-- 修改头像对话框 -->
  <div v-if="showChangeAvatarModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[2000]">
    <div class="bg-white rounded-lg p-6 w-96 shadow-xl">
      <h3 class="text-lg font-semibold mb-4">修改头像</h3>
      <div class="mb-4">
         <ComponentUpload
            :multiple="false"
            accept=".jpg,.jpeg,.png,.gif"
            :max-size="2 * 1024 * 1024"
            action="/api/upload" 
            v-model="newAvatarUrl"
          />
      </div>
      <div class="flex justify-end space-x-2">
         <button @click="showChangeAvatarModal = false" class="px-4 py-2 text-sm bg-gray-200 text-gray-700 rounded hover:bg-gray-300">取消</button>
         <button @click="submitChangeAvatar" class="px-4 py-2 text-sm bg-blue-500 text-white rounded hover:bg-blue-600">确认修改</button>
      </div>
    </div>
  </div>

  <!-- 修改密码对话框 -->
  <div v-if="showChangePasswordModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[2000]">
    <div class="bg-white rounded-lg p-6 w-96 shadow-xl">
      <h3 class="text-lg font-semibold mb-4">修改密码</h3>
      <div class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">当前密码</label>
          <input 
            v-model="passwordForm.oldPassword" 
            type="password"
            class="w-full border rounded-lg p-2 text-sm focus:outline-none focus:border-blue-500" 
            placeholder="请输入当前密码"
          />
          <p v-if="passwordFormErrors.oldPassword" class="text-red-500 text-xs mt-1">{{ passwordFormErrors.oldPassword }}</p>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">新密码</label>
          <input 
            v-model="passwordForm.newPassword" 
            type="password"
            class="w-full border rounded-lg p-2 text-sm focus:outline-none focus:border-blue-500" 
            placeholder="请输入新密码（至少6位）"
          />
          <p v-if="passwordFormErrors.newPassword" class="text-red-500 text-xs mt-1">{{ passwordFormErrors.newPassword }}</p>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">确认新密码</label>
          <input 
            v-model="passwordForm.confirmPassword" 
            type="password"
            class="w-full border rounded-lg p-2 text-sm focus:outline-none focus:border-blue-500" 
            placeholder="请再次输入新密码"
          />
          <p v-if="passwordFormErrors.confirmPassword" class="text-red-500 text-xs mt-1">{{ passwordFormErrors.confirmPassword }}</p>
        </div>
      </div>
      <div class="flex justify-end space-x-2 mt-6">
        <button 
          @click="showChangePasswordModal = false" 
          class="px-4 py-2 text-sm bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
        >
          取消
        </button>
        <button 
          @click="submitChangePassword" 
          class="px-4 py-2 text-sm bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          确认修改
        </button>
      </div>
     </div>
   </div>

  <!-- 修改授权码对话框 -->
  <div v-if="showChangeAuthCodeModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[2000]">
    <div class="bg-white rounded-lg p-6 w-96 shadow-xl">
      <h3 class="text-lg font-semibold mb-4">修改授权码</h3>
      <div class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">原始授权码</label>
          <input 
            v-model="authCodeForm.oldAuthCode" 
            type="password"
            maxlength="4"
            class="w-full border rounded-lg p-2 text-sm focus:outline-none focus:border-blue-500" 
            placeholder="请输入原始授权码"
          />
          <p v-if="authCodeFormErrors.oldAuthCode" class="text-red-500 text-xs mt-1">{{ authCodeFormErrors.oldAuthCode }}</p>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">新授权码</label>
          <input 
            v-model="authCodeForm.newAuthCode" 
            type="password"
            maxlength="4"
            class="w-full border rounded-lg p-2 text-sm focus:outline-none focus:border-blue-500" 
            placeholder="请输入新授权码（4位数字）"
          />
          <p v-if="authCodeFormErrors.newAuthCode" class="text-red-500 text-xs mt-1">{{ authCodeFormErrors.newAuthCode }}</p>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">确认新授权码</label>
          <input 
            v-model="authCodeForm.confirmAuthCode" 
            type="password"
            maxlength="4"
            class="w-full border rounded-lg p-2 text-sm focus:outline-none focus:border-blue-500" 
            placeholder="请再次输入新授权码"
          />
          <p v-if="authCodeFormErrors.confirmAuthCode" class="text-red-500 text-xs mt-1">{{ authCodeFormErrors.confirmAuthCode }}</p>
        </div>
      </div>
      <div class="flex justify-end space-x-2 mt-6">
        <button 
          @click="showChangeAuthCodeModal = false" 
          class="px-4 py-2 text-sm bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
        >
          取消
        </button>
        <button 
          @click="submitChangeAuthCode" 
          class="px-4 py-2 text-sm bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          确认修改
        </button>
      </div>
     </div>
   </div>

  <!-- 退出登录确认对话框 -->
  <div v-if="showLogoutDialog" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[2000]">
    <div class="bg-white rounded-lg p-6 w-96 shadow-xl">
      <div class="text-center">
        <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-orange-100 mb-4">
          <i class="fas fa-sign-out-alt text-orange-600"></i>
        </div>
        <h3 class="text-lg font-medium text-gray-900 mb-2">确认退出</h3>
        <p class="text-sm text-gray-500 mb-4">
          确定要退出登录吗？
        </p>
      </div>
      
      <div class="flex justify-end space-x-3">
        <button 
          @click="cancelLogout" 
          class="px-4 py-2 text-sm bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
        >
          取消
        </button>
        <button 
          @click="confirmLogout" 
          class="px-4 py-2 text-sm bg-orange-500 text-white rounded hover:bg-orange-600"
        >
          确认退出
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineEmits, onMounted, onUnmounted } from "vue";
import { useRouter } from 'vue-router';
import { messagesApi, financeApi, purchaseApi, salesApi, purchaseReturnApi, userApi} from "@/api/api";
import MessageDetail from '@/views/settings/MessageDetail.vue';
import ComponentDialog from '@/components/ComponentDialog.vue';
import ComponentUpload from '@/components/ComponentUpload.vue';
import { toast } from '@/utils/toast.js';
 

const emit = defineEmits(["toggle-sidebar"]);
const router = useRouter();

// 用户信息
const userInfo = ref({
  name: '陈经理',
  avatar: 'https://ai-public.mastergo.com/ai/img_res/c915ca0fd74bfb9f4821648e02185883.jpg',
  role: [],
  merchantId: null,
  companyName: ''
});
const avatarUrl = ref(userInfo.value.avatar);
const normalizeRoles = (roles) => {
  if (!roles) {
    return [];
  }
  return (Array.isArray(roles) ? roles : [roles]).map(role => String(role).toLowerCase());
};
const roleBadge = computed(() => {
  const roles = normalizeRoles(userInfo.value.role);
  const merchantId = userInfo.value.merchantId;
  const hasRole = (role) => roles.includes(role);

  if (hasRole('super_admin') || (hasRole('admin') && !merchantId)) {
    return { text: '平台管理员', className: 'bg-purple-50 text-purple-700 border-purple-200' };
  }
  return { text: '', className: '' };
});
const messages = ref([]);
const unreadCount = ref(0);
const showMessagePanel = ref(false);

// 进货相关数据
const pendingPurchases = ref([]);
const pendingPurchaseCount = ref(0);
const showPurchasePanel = ref(false);

const pagination = ref({
    total: 0,
    current: 1,
    pageSize: 10
  });
const messageId = ref(null);
const messageCount=ref(null);
// 用户菜单相关
const showUserMenu = ref(false);
const showChangePasswordModal = ref(false);
const showChangeAuthCodeModal = ref(false);
const showChangeAvatarModal = ref(false);
const newAvatarUrl = ref('');
const showLogoutDialog = ref(false);
const passwordForm = ref({
  oldPassword: '',
  newPassword: '',
  confirmPassword: ''
});
const passwordFormErrors = ref({});
const authCodeForm = ref({
  oldAuthCode: '',
  newAuthCode: '',
  confirmAuthCode: ''
});
const authCodeFormErrors = ref({});

// 消息刷新配置
//const messageRefreshInterval = ref(process.env.VUE_APP_MESSAGE_REFRESH_INTERVAL || 30000); // 改为30秒，减少服务器压力
let refreshTimer = null;
//let isRefreshing = ref(false); // 防止重复刷新
const toggleSidebar = () => {
  emit("toggle-sidebar");
};

const toggleMessagePanel = async (event) => {
  event.stopPropagation();
  
  // 如果进货面板打开，先关闭它
  if (showPurchasePanel.value) {
    closePurchasePanel();
  }
  
  showMessagePanel.value = !showMessagePanel.value;
  if (showMessagePanel.value) {
    await loadMessages();
    setTimeout(() => {
      window.addEventListener('click', closeMessagePanel);
    }, 0);
  } else {
    window.removeEventListener('click', closeMessagePanel);
  }
};

const closeMessagePanel = () => {
  showMessagePanel.value = false;
  window.removeEventListener('click', closeMessagePanel);
};

// 进货面板相关方法
const togglePurchasePanel = async (event) => {
  event.stopPropagation();
  
  // 如果消息面板打开，先关闭它
  if (showMessagePanel.value) {
    closeMessagePanel();
  }
  
  showPurchasePanel.value = !showPurchasePanel.value;
  if (showPurchasePanel.value) {
    await loadPendingPurchases();
    setTimeout(() => {
      window.addEventListener('click', closePurchasePanel);
    }, 0);
  } else {
    window.removeEventListener('click', closePurchasePanel);
  }
};

const closePurchasePanel = () => {
  showPurchasePanel.value = false;
  window.removeEventListener('click', closePurchasePanel);
};

const loadPendingPurchases = async () => {
  try {
    // 获取进货待销售列表
    const listResponse = await purchaseApi.getPendingSalesList({
      search: {
        keyword: ""
      },
      pagination: {
        current: pagination.value.current,
        pageSize: pagination.value.pageSize
      }
    });
    console.log("listResponse",listResponse);
    if (listResponse.success) {
      pendingPurchases.value = listResponse.data.list;
      pendingPurchaseCount.value = listResponse.data.pagination.total;
    }
  } catch (error) {
    console.error("加载进货待销售数据失败:", error);
    // 设置默认值，避免界面错误
    pendingPurchaseCount.value = 0;
    pendingPurchases.value = [];
  }
};

const getProductNames = (productsJson) => {
  try {
    // 检查输入是否为null或undefined
    if (!productsJson) {
      return '暂无商品信息';
    }
    
    // 如果已经是数组，直接处理
    if (Array.isArray(productsJson)) {
      return productsJson.map(p => p?.productName || p?.name || '未知商品').join(', ') || '暂无商品信息';
    }
    
    // 尝试解析JSON字符串
    const products = JSON.parse(productsJson);
    if (!Array.isArray(products) || products.length === 0) {
      return '暂无商品信息';
    }
    
    return products.map(p => p?.productName || p?.name || '未知商品').join(', ');
  } catch (error) {
    console.warn('商品信息解析失败:', error);
    return '商品信息解析失败';
  }
};

const convertToSales = async (purchase) => {
  try {
    // 显示加载提示
    toast.info('正在获取进货单详情...');
    
    // 调用API获取完整的进货单详情
    const response = await purchaseApi.getPurchaseById(purchase.purchaseOrderId);
    
    if (!response.success) {
      toast.error('获取进货单详情失败');
      return;
    }
    console.log("purchasedetail",response);
    const purchaseDetail = response.data;
    
    // 将商品数据转换为销售单格式，参考PurchaseListDetail.vue的实现
    const productsData = purchaseDetail.items?.map(item => ({
      productId: item.productId,
      productInfo: item.productName,
      mediaUrl: item.productMediaUrl || '',
      specification: item.specification || '',
      unit: item.unit || '',
      warehouse: item.warehouse || '',
      quantity: item.quantity,
      price: item.productPrice,
      costprice: item.costPrice || item.price, // 如果没有成本价，使用销售价
      discount: item.discount || 100,
      discountprice: item.productPrice,
      remarks: item.remarks || ''
    })) || [];
    
    // 保存仓库信息
    const warehouseData = {
      id: purchaseDetail.warehouseId,
      name: purchaseDetail.warehouseName || '默认仓库'
    };
    
    // 将数据保存到localStorage，供销售单页面使用
    localStorage.setItem('purchaseNo', purchase.orderNo); 
    localStorage.setItem('purchaseToSalesRemarks', purchase.remarks);
    localStorage.setItem('purchaseToSalesProducts', JSON.stringify(productsData));
    localStorage.setItem('purchaseToSalesWarehouse', JSON.stringify(warehouseData));
    
    // 关闭面板
    closePurchasePanel();
    //await purchaseApi.markAsSold(purchase.id);
    // 跳转到销售新增页面
    router.push({
      path: '/Sales/SalesAdd',
      query: { fromPurchase: 'true' }
    });
    
    toast.success('正在跳转到销售单页面');
    
  } catch (error) {
    console.error('进货转销售失败:', error);
    toast.error('进货转销售失败，请稍后重试');
  }
};

// 标记已售方法
const markAsSold = async (purchase) => {
  try {
    // 显示加载提示
    toast.info('正在标记为已售...');
    
    // 调用API标记为已售
    const response = await purchaseApi.markAsSold(purchase.id);
    
    if (response.success) {
      toast.success('标记已售成功');
      
      // 重新加载进货待销售数据，更新列表
      await loadPendingPurchases();
    } else {
      toast.error('标记已售失败：' + (response.message || '未知错误'));
    }
    
  } catch (error) {
    console.error('标记已售失败:', error);
    toast.error('标记已售失败，请稍后重试');
  }
};

const loadMessages = async () => {
  //console.log("headlogo",avatarUrl.value)
  try { 
    const response = await messagesApi.getMessages({
        pagination: {
          current: pagination.value.current,
          pageSize: pagination.value.pageSize
        },
        search: {
          isread:false,
        },
        sort: {
          predicate: "createdOn",
          reverse: true
        }
      } );
      //console.log(response);
      if(response.success){
        messages.value = response.data.list.map(msg => ({
      id: msg.id,
      orderType: msg.orderType,
      title: msg.messageTitle,
      orderId: msg.orderId,
      orderNo: msg.orderNo,
      content: msg.messageContent,
      createdOn: msg.createdOn,
      isRead: msg.isRead,
      needApproval: msg.isShowButton,
      submitter: msg.createdName,
      isShowButton: msg.isShowButton,
      attachmentUrl: JSON.parse(msg.attachmentUrl || '[]'), 
    }));
    messageCount.value=response.data.pagination.total;
    //onsole.log("msg",messages.value);
    await updateUnreadCount();
    //await loadPendingPurchases(); // 加载进货待销售数据
    }
    
  } catch (error) {
    console.error("加载消息失败:", error);
    // 这里可以添加UI错误提示
  }
};

const markAsRead = async (messageId) => {
  try {
    const response = await messagesApi.markMessageAsRead({
      "messageId": messageId
    });
    //const message = messages.value.find(m => m.id === messageId);
    // if (message) message.isRead = true;
    // await updateUnreadCount();
    if (response.success) {
      await loadMessages();
    }
  } catch (error) {
    console.error("标记消息已读失败:", error);
  }
};

const updateUnreadCount = async () => {
  try {
    // 计算未读消息数量
    unreadCount.value = messageCount.value;
  } catch (error) {
    console.error("获取未读消息数量失败:", error);
  }
};

const showMessageDetail = ref(false);
const messageData = ref(null);

const handleMessageClick = async (message) => {
  //alert(message.id);
  //await markAsRead(message.id); 
  messageId.value = message.id;
  messageData.value = message;
  showMessageDetail.value = true;
  //console.log("msg",messageData.value);
  closeMessagePanel();
};
const formatDate = (dateString) => {
  try {
    // 检查输入是否为null或undefined
    if (!dateString) {
      return '未知时间';
    }
    
    const date = new Date(dateString);
    
    // 检查日期是否有效
    if (isNaN(date.getTime())) {
      return '无效日期';
    }
    
    return date.toLocaleString("zh-CN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    });
  } catch (error) {
    console.warn('日期格式化失败:', error);
    return '日期格式化失败';
  }
};

// 从localStorage加载用户信息
const loadUserInfo = () => {
  try {
    const storedUserInfo = localStorage.getItem('userInfo');
    if (storedUserInfo) {
      const parsedUserInfo = JSON.parse(storedUserInfo);
      userInfo.value = {
        name: parsedUserInfo.name || '用户',
        avatar: parsedUserInfo.avatar || 'https://ai-public.mastergo.com/ai/img_res/c915ca0fd74bfb9f4821648e02185883.jpg',
        role: parsedUserInfo.role || parsedUserInfo.roles || [],
        merchantId: parsedUserInfo.merchantId || parsedUserInfo.MerchantId || null,
        companyName: parsedUserInfo.companyName || parsedUserInfo.CompanyName || ''
      };
      avatarUrl.value = userInfo.value.avatar;
    }
  } catch (error) {
    console.error('加载用户信息失败:', error);
  }
};

// 验证用户权限
const checkUserPermissions = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      console.warn('用户未登录，跳转到登录页面');
      // 可以在这里添加跳转到登录页面的逻辑
      return false;
    }
    
    // 这里可以添加更多的权限验证逻辑
    // 例如验证token是否有效，用户是否有相应权限等
    
    return true;
  } catch (error) {
    console.error('用户权限验证失败:', error);
    return false;
  }
};

onMounted(async () => {
  try {
    // 1. 加载用户信息
    loadUserInfo();
    
    // 2. 验证用户权限
    const hasPermission = await checkUserPermissions();
    if (!hasPermission) {
      return; // 如果没有权限，直接返回
    }
    
    // 3. 初始加载数据
    //await updateUnreadCount();
    //await loadMessages(); // 加载消息数据
    //await loadPendingPurchases(); // 加载进货待销售数据
    
    // 4. 启动定时刷新器
    //  refreshTimer = setInterval(async () => {
    //    // 防止重复刷新
    //    if (isRefreshing.value) {
    //      console.log('正在刷新中，跳过本次定时刷新');
    //      return;
    //    }
       
    //    try {
    //      isRefreshing.value = true;
    //      console.log('开始定时刷新数据...');
         
    //      // 并行执行两个数据加载，提高效率
    //      await Promise.all([
    //        loadMessages(), // 定时刷新消息数据
    //        loadPendingPurchases() // 定时刷新进货待销售数据
    //      ]);
         
    //      console.log('定时刷新数据完成');
    //    } catch (error) {
    //      console.error('定时刷新数据失败:', error);
    //    } finally {
    //      isRefreshing.value = false;
    //    }
    //  }, messageRefreshInterval.value);
    
    // console.log('HeaderBar初始化完成，定时器已启动');
  } catch (error) {
    console.error('HeaderBar初始化失败:', error);
  }
});

// 组件卸载时清理资源
onUnmounted(() => {
  // 清理定时器
  if (refreshTimer) {
    clearInterval(refreshTimer);
    refreshTimer = null;
    console.log('定时器已清理');
  }
  
  // 清理事件监听器
  window.removeEventListener('click', closeUserMenu);
  window.removeEventListener('click', closeMessagePanel);
  window.removeEventListener('click', closePurchasePanel);
  
  console.log('HeaderBar组件资源清理完成');
});

// 驳回理由对话框状态
const showRejectDialog = ref(false);
const rejectReason = ref('');
const currentMessageId = ref(null);
const rejectReasonError = ref('');

const handleApprove = async (messageId) => {
  try {
    // 根据消息类型选择正确的API接口
    const message = messages.value.find(m => m.id === messageId);
    console.log("msg",message);
    
    const auditData = {
      orderId: message.orderId,
      messageId: message.id,
      rejectReason: ""
    };
    
    // XSD = 0 销售单
    if(message.orderType === 0){
      const response = await salesApi.AuditOrder(message.orderId);
      if(response.success){
        await messagesApi.markMessageAsRead({"messageId": auditData.messageId});
        toast.success("审批成功");
      } 
    }
    // JHD = 1 进货单
    else if(message.orderType === 1){
      const response = await purchaseApi.AuditOrder(auditData);
      if(response.success){
         await messagesApi.markMessageAsRead({"messageId": auditData.messageId});
        toast.success("审批成功");
      } 
    }
    // INV = 2 开票单
    else if(message.orderType === 2){
      const response = await financeApi.AuditOrder(auditData);
      if(response.success){
         await messagesApi.markMessageAsRead({"messageId": auditData.messageId});
        toast.success("审批成功");
      } 
    } 
    else if(message.orderType === 3){
      const response = await salesApi.AuditSaleReturn(auditData.orderId);
      if(response.success){
         await messagesApi.markMessageAsRead({"messageId": auditData.messageId});
        toast.success("审批成功");
      } 
    }
    // JHTD = 3 进货退货单
    else if(message.orderType === 4){
      const response = await purchaseReturnApi.AuditOrder(auditData.orderId);
      if(response.success){
         await messagesApi.markMessageAsRead({"messageId": auditData.messageId});
        toast.success("审批成功");
      } 
    }
    // XSTD = 4 销售退货单
   
    
    await loadMessages();
  } catch (error) {
    console.error('审批操作失败:', error);
  }
};

// const handleReject = async (messageId) => {
//   // 显示驳回理由输入对话框
//   currentMessageId.value = messageId;
//   showRejectDialog.value = true;
//   rejectReason.value = '';
//   rejectReasonError.value = '';
// };

const submitReject = async () => {
  // 验证驳回理由
  if (!rejectReason.value.trim()) {
    rejectReasonError.value = '请输入驳回理由';
    return;
  }
  
  try {
    const message = messages.value.find(m => m.id === currentMessageId.value);
    
    const rejectData = {
      orderId: message.orderId,
      messageId: message.id,
      rejectReason: rejectReason.value
    };
    
    // XSD = 0 销售单
    if(message.orderType === 0){
      const response = await salesApi.UnAuditOrder(rejectData.orderId);
        if(response.success){
         await messagesApi.markMessageAsRead({"messageId": rejectData.messageId});
        toast.success("操作成功");
      } 
    }
    // JHD = 1 进货单
    else if(message.orderType === 1){
      const response = await purchaseApi.UnAuditOrder(rejectData);
       if(response.success){
         await messagesApi.markMessageAsRead({"messageId": rejectData.messageId});
        toast.success("操作成功");
      } 
    }
    // INV = 2 开票单
    else if(message.orderType === 2){
      const response = await financeApi.UnAuditOrder(rejectData);
       if(response.success){
         await messagesApi.markMessageAsRead({"messageId": rejectData.messageId});
        toast.success("操作成功");
      } 
    }
    // JHTD = 3 进货退货单
    else if(message.orderType === 4){
      const response = await purchaseReturnApi.UnAuditOrder(rejectData);
       if(response.success){
         await messagesApi.markMessageAsRead({"messageId": rejectData.messageId});
        toast.success("操作成功");
      } 
    }
    // XSTD = 4 销售退货单
    else if(message.orderType === 3){
      const response = await salesApi.UnAuditSaleReturn(rejectData.orderId);
       if(response.success){
         await messagesApi.markMessageAsRead({"messageId": rejectData.messageId});
        toast.success("操作成功");
      } 
    }
    
    // 关闭对话框并刷新消息列表
    showRejectDialog.value = false;
    await loadMessages();
  } catch (error) {
    toast.error('驳回操作失败:'+ error);
    console.error('驳回操作失败:', error);
  }
};

const cancelReject = () => {
  showRejectDialog.value = false;
  rejectReason.value = '';
  rejectReasonError.value = '';
};

// 用户菜单相关方法
const toggleUserMenu = (event) => {
  event.stopPropagation();
  
  // 如果其他面板打开，先关闭它们
  if (showMessagePanel.value) {
    closeMessagePanel();
  }
  if (showPurchasePanel.value) {
    closePurchasePanel();
  }
  
  showUserMenu.value = !showUserMenu.value;
  if (showUserMenu.value) {
    setTimeout(() => {
      window.addEventListener('click', closeUserMenu);
    }, 0);
  } else {
    window.removeEventListener('click', closeUserMenu);
  }
};

const closeUserMenu = () => {
  showUserMenu.value = false;
  window.removeEventListener('click', closeUserMenu);
};

const showChangePasswordDialog = () => {
  showChangePasswordModal.value = true;
  showUserMenu.value = false;
  // 重置表单
  passwordForm.value = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  };
  passwordFormErrors.value = {};
};

const showChangeAvatarDialog = () => {
  showChangeAvatarModal.value = true;
  showUserMenu.value = false;
  newAvatarUrl.value = '';
};

const submitChangeAvatar = async () => {
  if (!newAvatarUrl.value) {
    toast.error('请先上传新头像');
    return;
  }
  
  try {
     const response = await userApi.changeAvatar({ avatarUrl: newAvatarUrl.value });
     if (response.success) {
       toast.success('头像修改成功');
       showChangeAvatarModal.value = false;
       // Update local state
       userInfo.value.avatar = newAvatarUrl.value;
       avatarUrl.value = newAvatarUrl.value;
       // Update local storage
       const storedUserInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
       storedUserInfo.avatar = newAvatarUrl.value;
       localStorage.setItem('userInfo', JSON.stringify(storedUserInfo));
     } else {
       toast.error(response.message || '修改失败');
     }
  } catch (error) {
     console.error(error);
     toast.error('修改失败');
  }
};

const validatePasswordForm = () => {
  const errors = {};
  
  if (!passwordForm.value.oldPassword) {
    errors.oldPassword = '请输入当前密码';
  }
  
  if (!passwordForm.value.newPassword) {
    errors.newPassword = '请输入新密码';
  } else if (passwordForm.value.newPassword.length < 6) {
    errors.newPassword = '新密码至少6位';
  }
  
  if (!passwordForm.value.confirmPassword) {
    errors.confirmPassword = '请确认新密码';
  } else if (passwordForm.value.newPassword !== passwordForm.value.confirmPassword) {
    errors.confirmPassword = '两次输入的密码不一致';
  }
  
  passwordFormErrors.value = errors;
  return Object.keys(errors).length === 0;
};

const submitChangePassword = async () => {
  if (!validatePasswordForm()) {
    return;
  }
  
  try {
    // 准备提交数据
    const submitData = {
      oldPassword: passwordForm.value.oldPassword.trim(),
      newPassword: passwordForm.value.newPassword.trim(),
      confirmPassword: passwordForm.value.confirmPassword.trim()
    };
    
    console.log('修改密码请求数据:', { oldPassword: '***', newPassword: '***' });
    
    const response = await userApi.changePassword(submitData);
    console.log('修改密码响应:', response);
    
    if (response && response.success) {
      toast.success('密码修改成功！请重新登录');
      showChangePasswordModal.value = false;
      // 重置表单
      passwordForm.value = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
      passwordFormErrors.value = {};
      
      // 延迟跳转到登录页面
      // setTimeout(() => {
      //   router.push('/login');
      // }, 2500);
    } else {
      const errorMsg = response?.message || response?.data?.message || '修改密码失败';
      toast.error(errorMsg);
    }
  } catch (error) {
    console.error('修改密码失败:', error);
    let errorMessage = '修改密码失败，请重试';
    
    if (error.response) {
      // 服务器返回错误
      if (error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      } else if (error.response.data && typeof error.response.data === 'string') {
        errorMessage = error.response.data;
      } else if (error.response.status) {
        errorMessage = `服务器错误 (${error.response.status})`;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    toast.error(errorMessage);
  }
};
  
  const logout = () => {
  showLogoutDialog.value = true;
  showUserMenu.value = false;
};

const showChangeAuthCodeDialog = () => {
  showChangeAuthCodeModal.value = true;
  showUserMenu.value = false;
  // 重置表单
  authCodeForm.value = {
    oldAuthCode: '',
    newAuthCode: '',
    confirmAuthCode: ''
  };
  authCodeFormErrors.value = {};
};

const validateAuthCodeForm = () => {
  const errors = {};
  
  if (!authCodeForm.value.oldAuthCode) {
    errors.oldAuthCode = '请输入原始授权码';
  } else if (authCodeForm.value.oldAuthCode.length !== 4 || isNaN(authCodeForm.value.oldAuthCode)) {
    errors.oldAuthCode = '授权码必须是4位数字';
  }

  if (!authCodeForm.value.newAuthCode) {
    errors.newAuthCode = '请输入新授权码';
  } else if (authCodeForm.value.newAuthCode.length !== 4 || isNaN(authCodeForm.value.newAuthCode)) {
    errors.newAuthCode = '新授权码必须是4位数字';
  }
  
  if (!authCodeForm.value.confirmAuthCode) {
    errors.confirmAuthCode = '请确认新授权码';
  } else if (authCodeForm.value.newAuthCode !== authCodeForm.value.confirmAuthCode) {
    errors.confirmAuthCode = '两次输入的授权码不一致';
  }
  
  authCodeFormErrors.value = errors;
  return Object.keys(errors).length === 0;
};

const submitChangeAuthCode = async () => {
  if (!validateAuthCodeForm()) {
    return;
  }
  
  try {
    const submitData = {
      oldAuthCode: authCodeForm.value.oldAuthCode,
      authCode: authCodeForm.value.newAuthCode
    };
    
    const response = await userApi.changeAuthCode(submitData);
    
    if (response.success) {
      toast.success('授权码修改成功');
      showChangeAuthCodeModal.value = false;
      authCodeForm.value = {
        oldAuthCode: '',
        newAuthCode: '',
        confirmAuthCode: ''
      };
      authCodeFormErrors.value = {};
    } else {
      toast.error(response.message || '修改失败');
    }
  } catch (error) {
    console.error('修改授权码失败:', error);
    toast.error('修改授权码失败，请重试');
  }
};

const confirmLogout = () => {
  try {
    // 清除本地存储的用户信息
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('user');
    
    // 清除会话存储
    sessionStorage.clear();
    
    toast.success('已成功退出登录');
    
    // 延迟跳转，让用户看到成功消息
    setTimeout(() => {
      window.location.href = '/login';
    }, 1000);
  } catch (error) {
    console.error('退出登录失败:', error);
    toast.error('退出登录失败，请重试');
  }
  showLogoutDialog.value = false;
};

const cancelLogout = () => {
  showLogoutDialog.value = false;
};
</script>


 
